import React from "react";

const DebitOrderConsentAgreement = ({ companyName = '', clientAddress = '', clientName = '', amount = '____', dayOfMonth = '____', months = '____', startDate = '______________________________', bankName = '', branchCode = '', accountNumber = '', accountType = '' }) => {
  const lenderName = companyName || '______________________________';
  const residingAt = clientAddress || '______________________________';

  return (
    <div className="mt-8">
      <h2 className="font-bold text-base mb-4 uppercase">DEBIT ORDER CONSENT AGREEMENT</h2>
      <p className="text-sm mb-2">I, {clientName || '______________________________'}, residing at {residingAt}, hereby grant consent to {lenderName}, as follows:</p>
      <p className="text-sm mb-2">I authorise {lenderName} to deduct an amount of N${amount} monthly via debit order from my account on the {dayOfMonth} of each month for {months} months, starting from {startDate}.</p>
      <p className="text-sm mb-2">If the deduction date falls on a Saturday or Sunday, the deduction will be made on the last working day before it (the Friday).</p>
      <p className="text-sm mb-2">If the debit order deduction fails on the agreed date due to insufficient funds or any other reason, I consent to {lenderName} attempting a withdrawal from my account at any time thereafter, as they deem necessary, until the outstanding amount is collected.</p>
      <div className="mt-4">
        <p className="text-sm mb-1">Client Banking Details</p>
        <p className="text-sm mb-1">Bank Name: {bankName || '________________________________________'}</p>
        <p className="text-sm mb-1">Branch Code: {branchCode || '_____________________________________'} </p>
        <p className="text-sm mb-1">Account Number: {accountNumber || '__________________________________'}</p>
        <p className="text-sm mb-1">Account Type: {accountType || 'Cheque           Savings          Transmission'}</p>
      </div>
    </div>
  );
};

export default DebitOrderConsentAgreement;
